    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">


                        <el-form-item label="容量:">
                            <el-select v-model="table.where.ml_id" filterable placeholder="请选择">
                                <el-option v-for="item in custom_ml_list" :key="item.id"
                                    :label="item.custom_menu.name+'-'+ item.name" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="模型名称:">
                            <el-input v-model="table.where.name" placeholder="请输入模型名称" clearable />
                        </el-form-item>




                        <el-form-item label="空白瓶宽度:">
                            <el-input-number v-model="table.where.image_width" placeholder="请输入空白瓶宽度" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>



                        <el-form-item label="状态:">
                            <el-select v-model="table.where.status" filterable placeholder="请选择">
                                <el-option label="显示" value="1"></el-option>
                                <el-option label="不显示" value="2"></el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>

                        <el-form-item label="贴图方式:">
                            <el-select v-model="table.where.image_type" filterable placeholder="请选择">
                                <el-option label="单图" value="1"></el-option>
                                <el-option label="双图" value="2"></el-option>
                            </el-select>
                        </el-form-item>


                        <el-form-item label="排序:">
                            <el-input-number v-model="table.where.sort" placeholder="请输入排序" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon" v-if="permission.includes('sys:customcontainer:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:customcontainer:add')">添加
                    </el-button>

                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:customcontainer:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                        <el-table-column prop="ml_id" label="容量斤数关联" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.ml_id_info"
                                    :key="index">{{row.ml_info.custom_name}}-{{row.ml_info.name}}</el-tag>
                            </template>
                        </el-table-column>


                        <el-table-column prop="name" label="模型名称" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="thumbnail" label="列表图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.thumbnail"
                                    :preview-src-list="[row.thumbnail]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="image" label="空白瓶图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.image"
                                    :preview-src-list="[row.image]">
                                </el-image>
                            </template>
                        </el-table-column>
                        <el-table-column prop="bottle_cap_image" label="瓶盖图" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.bottle_cap_image"
                                    :preview-src-list="[row.bottle_cap_image]">
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column prop="image_width" label="空白瓶宽度" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="binfile" label="解压后模型文件路径" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <a :href="row.binfile" target="_blank"><el-tag>文件</el-tag></a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="status" label="状态" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-switch v-model="row.status" @change="editStatus(row,'status')" :active-value="1"
                                    :inactive-value="0" />
                            </template>
                        </el-table-column>
                        <el-table-column prop="image_type" label="贴图方式" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-if="row.image_type == 1" :key="index">单图</el-tag>
                                <el-tag v-if="row.image_type == 2" :key="index">双图</el-tag>
                            </template>
                        </el-table-column>

                        <el-table-column prop="zipfile" label="zip文件" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <a :href="row.zipfile" target="_blank"><el-tag>文件</el-tag></a>
                            </template>
                        </el-table-column>

                        <el-table-column prop="sort" label="排序" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="background_file" label="背景文件" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <a :href="row.background_file" target="_blank"><el-tag>文件</el-tag></a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ml_id_info.id" label="" sortable="custom" show-overflow-tooltip
                            min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.ml_id_info" :key="index">
                                    {{ item.id }}
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="ml_id_info.custom_id" label="定制菜单id" sortable="custom"
                            show-overflow-tooltip min-width="120">
                            <template slot-scope="{row}">
                                <div v-for="(item,index) in row.ml_id_info" :key="index">
                                    {{ item.custom_id }}
                                </div>
                            </template>
                        </el-table-column>

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:customcontainer:edit')">修改</el-link>
                                <el-link @click="resourceInfo(row)" icon="el-icon-edit" type="primary"
                                    :underline="false"
                                    v-if="permission.includes('sys:customcontainer:edit')">资源</el-link>
                                <el-popconfirm title="确定要删除此定制模型管理吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:customcontainer:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改定制模型管理':'添加定制模型管理'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :inline="true" :model="editForm" ref="editForm" :rules="editRules" label-width="auto"
                    class="demo-ruleForm">


                    <el-form-item label="容量斤数关联:" prop="ml_id">
                        <el-select v-model="editForm.ml_id" filterable placeholder="请选择">
                            <el-option v-for="item in custom_ml_list" :key="item.id"
                                :label="item.custom_menu.name+'-'+item.name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="模型名称:" prop="name">
                        <el-input v-model="editForm.name" placeholder="请输入模型名称" clearable />
                    </el-form-item>


                    <el-form-item label="列表图:" prop="thumbnail">
                        <ele-uploadimage :limit="1" v-model="editForm.thumbnail"></ele-uploadimage>

                    </el-form-item>


                    <el-form-item label="空白瓶图:" prop="image">
                        <ele-uploadimage :limit="1" v-model="editForm.image"></ele-uploadimage>

                    </el-form-item>


                    <el-form-item label="瓶盖图:" prop="bottle_cap_image">
                        <ele-uploadimage :limit="1" v-model="editForm.bottle_cap_image"></ele-uploadimage>

                    </el-form-item>

                    <!--   <el-form-item label="空白瓶宽度:" prop="image_width">
                        <el-input-number v-model="editForm.image_width" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入空白瓶宽度" clearable />
                    </el-form-item> -->


                    <el-form-item label="状态:" prop="status">
                        <el-switch v-model="editForm.status" active-text="是" inactive-text="否" :active-value="1"
                            :inactive-value="0" />

                    </el-form-item>
                    <el-form-item label="资源状态:" prop="resource_status">
                        <el-switch v-model="editForm.resource_status" active-text="有" inactive-text="无"
                            :active-value="1" :inactive-value="0" />

                    </el-form-item>
                    <el-form-item label="首页状态:" prop="index_status">
                        <el-switch v-model="editForm.index_status" active-text="显示" inactive-text="隐藏" :active-value="1"
                            :inactive-value="2" />

                    </el-form-item>
                    <el-form-item label="zip文件:" prop="zipfile">
                        <ele-upload-resource-other :limit="1" v-model="editForm.zipfile"></ele-upload-resource-other>
                    </el-form-item>
                    <el-form-item label="贴图方式:" prop="image_type">
                        <el-select v-model="editForm.image_type" filterable placeholder="请选择贴图方式">
                            <el-option label="单图" value="1"></el-option>
                            <el-option label="双图" value="2"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="模型贴图顺序:" prop="order_sort">
                        <el-select v-model="editForm.order_sort" filterable placeholder="请选择贴图方式">
                            <el-option label="瓶盖 - 背面 - 正面" value="0,1,2"></el-option>
                            <el-option label="瓶盖 - 正面 - 背面" value="0,2,1"></el-option>
                            <el-option label="背面 - 瓶盖 - 正面" value="1,0,2"></el-option>
                            <el-option label="背面 - 正面 - 瓶盖" value="1,2,0"></el-option>
                            <el-option label="正面 - 背面 - 瓶盖" value="2,1,0"></el-option>
                            <el-option label="正面 - 瓶盖 - 背面" value="2,0,1"></el-option>
                        </el-select>
                    </el-form-item>


                    <el-form-item label="排序:" prop="sort">
                        <el-input-number v-model="editForm.sort" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入排序" clearable />
                    </el-form-item>


                    <el-form-item label="背景文件:" prop="background_image">
                        <ele-uploadimage :limit="1" v-model="editForm.background_image"></ele-uploadimage>

                    </el-form-item>
                    <el-form-item label="销量:" prop="sort">
                        <el-input-number v-model="editForm.sales" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入销量" clearable />
                    </el-form-item>
                    <el-form-item label="详情状态:" prop="detail_status">
                        <el-select v-model="editForm.detail_status" filterable placeholder="请选择">
                            <el-option label="显示" :value="1">
                            </el-option>
                            <el-option label="隐藏" :value="2">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="详细信息:" prop="detail_info">
                        <tinymce-editor v-model="editForm.detail_info" :init="initEditor" />
                    </el-form-item>

                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
            <el-dialog title="模型资源管理" :visible.sync="showEdit1" width="800px" :destroy-on-close="true"
                :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <ele-resource :showData="resource_data" :status="resource_status"></ele-resource>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";

        import EleUploadimage from '@/components/EleUploadimage'
        import EleUploadResourceOther from '@/components/EleUploadResourceOther'
        import TinymceEditor from '@/components/TinymceEditor'
        import EleResource from '@/views/custom/customcontainer/resource'
        export default {
            name: "SysCustomContainer",
            components: {
                EleUploadimage,
                EleUploadResourceOther,
                EleResource,
                TinymceEditor
            },
            data() {
                return {
                    resource_data: {
                        id: ''
                    },
                    resource_status: false,
                    showEdit1: false,
                    table: {
                        url: '/custom/CustomContainer/index',
                        where: {
                            "thumbnail": [],
                            "image": [],
                            "bottle_cap_image": [],
                            "binfile": [],
                            "zipfile": [],
                            "background_file": []
                        }
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        "thumbnail": [],
                        "image": [],
                        "bottle_cap_image": [],
                        "binfile": [],
                        "zipfile": [],
                        "background_file": []
                    }, // 表单数据
                    editFormTemp: {
                        "thumbnail": [],
                        "image": [],
                        "bottle_cap_image": [],
                        "binfile": [],
                        "zipfile": [],
                        "background_file": []
                    },
                    admin_list: [],
                    user_list: [],
                    search_show: false,
                    custom_ml_list: [],
                    editRules: { // 表单验证规则

                        ml_id: [{
                            required: true,
                            message: '请选择容量',
                            trigger: 'blur'
                        }],


                        name: [{
                            required: true,
                            message: '请输入模型名称',
                            trigger: 'blur'
                        }],


                        thumbnail: [{
                            required: true,
                            message: '请上传列表图',
                            trigger: 'blur'
                        }],


                        image: [{
                            required: true,
                            message: '请上传空白瓶图',
                            trigger: 'blur'
                        }],


                        bottle_cap_image: [{
                            required: true,
                            message: '请上传瓶盖图',
                            trigger: 'blur'
                        }],


                        image_width: [{
                            required: true,
                            message: '请输入空白瓶宽度',
                            trigger: 'blur'
                        }],


                        binfile: [{
                            required: true,
                            message: '请上传解压后模型文件路径',
                            trigger: 'blur'
                        }],


                        gitf_content: [{
                            required: true,
                            message: '请输入文件内容',
                            trigger: 'blur'
                        }],



                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],


                        image_type: [{
                            required: true,
                            message: '请选择贴图方式',
                            trigger: 'blur'
                        }],


                        zipfile: [{
                            required: true,
                            message: '请上传zip文件',
                            trigger: 'blur'
                        }],

                        id: [{
                            required: true,
                            message: '请输入',
                            trigger: 'blur'
                        }],

                        custom_id: [{
                            required: true,
                            message: '请输入定制菜单',
                            trigger: 'blur'
                        }],


                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
                initEditor() {
                    return {
                        height: 400,
                        file_picker_callback: this.file_picker_callback,
                        skin_url: this.$store.state.theme.theme === 'dark' ? '/tinymce/skins/ui/oxide-dark' :
                            '/tinymce/skins/ui/oxide',
                        content_css: this.$store.state.theme.theme === 'dark' ?
                            '/tinymce/skins/content/dark/content.css' : '/tinymce/skins/content/default/content.css',
                        images_upload_handler: (blobInfo, success, error) => {
                            let file = blobInfo.blob();
                            // 使用axios上传
                            const formData = new FormData();
                            formData.append('file', file, file.name);
                            this.$http.post('/upload/uploadImage', formData).then(res => {
                                if (res.data.code == 0) {
                                    success(res.data.data);
                                } else {
                                    error(res.data.msg);
                                }
                            }).catch(e => {
                                error(e.message);
                            });
                        }
                    };
                }
            },
            mounted() {

                this.CustomMlAllList();
            },
            methods: {
                resourceInfo(row) {
                    this.resource_data = {
                        id: row.id,
                    }
                    this.resource_status = true;
                    this.showEdit1 = true;
                },
                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/custom/CustomContainer/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                res.data.data.ml_id = parseInt(res.data.data.ml_id);
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/custom/CustomContainer/edit', this.editForm).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的定制模型管理吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/custom/CustomContainer/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/custom/CustomContainer/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/custom/CustomContainer/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },

                //查询其他信息
                CustomMlAllList() {
                    this.$http.post('/custom/CustomMl/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.custom_ml_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },

                /**
         * 更改状态

         */
                editStatus(row, name) {
                    const loading = this.$loading({
                        lock: true
                    });
                    let data = {
                        id: row.id,
                        name: name,
                        value: row[name],
                    }
                    this.$http.post("/custom/CustomContainer/status", data).then(res => {
                        loading.close();
                        if (res.data.code === 0) {
                            this.$message({
                                type: 'success',
                                message: res.data.msg
                            });
                        } else {
                            row[name] = !row[name] ? 1 : 0;
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        loading.close();
                        this.$message.error(e.message);
                    });
                },
            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>